import {Lyric} from './lyrics/lyric';
import {Genre} from '../genres/genre';
import {Tag} from '@common/tags/tag';
import {Artist} from '@app/web-player/artists/artist';
import {Album} from '@app/web-player/albums/album';
import { MediaStreamType } from '@common/player/state/player-state';
import { AlbumSubtype, AlbumType } from '@common/admin/use-album_taxonomies';
import {NormalizedModel} from '@ui/types/normalized-model';

export const TRACK_MODEL = 'track';

export interface DerivedSingleConfig {
  id?: number;
  target_artist_id: number;
  target_artist?: NormalizedModel;
  image_override?: string | null;
  name_override?: string | null;
  release_date_override?: string | null;
  k_release_date_override?: string | null;
}

export interface Track {
  id: number;
  name: string;
  album_type?: AlbumType;
  album_subtype?: AlbumSubtype;
  type?: string;
  player_type?: string;
  stream_type?: MediaStreamType;
  duration?: number;
  artists?: Artist[];
  plays?: number;
  popularity?: number;
  src?: string;
  image?: string;
  image_format?: 'square' | 'landscape' | 'poster' | 'portrait';
  artwork?: string;
  artwork_large?: string;
  thumb_16_9?: string;
  thumb_1080?: string;
  thumb_4_5?: string;
  thumb_9_16?: string;
  lyric?: Omit<Lyric, 'track'>;
  album?: Album;
  owner_id?: number;
  description?: string;
  tags: Tag[];
  genres?: Genre[];
  likes_count?: number;
  reposts_count?: number;
  comments_count?: number;
  updated_at?: string;
  created_at?: string;
  // available in library tracks page only
  added_at?: string;
  model_type: 'track';
  available?: boolean;
  encoded?: boolean;
  exclusivity?: boolean;
  is_searchable?: boolean;
  is_channel_visible?: boolean;
  inherit_release_dates?: boolean;
  release_date?: string;
  k_release_date?: string | undefined;
  isAvailable?: boolean | undefined;
  isExclusivity?: boolean | undefined;
  isReleased?: boolean | undefined;
  isEncoded?: boolean | undefined;
  releaseDate?: string;
  derived_single_mode?: 'inherit' | 'disabled' | 'custom';
  derived_singles?: DerivedSingleConfig[];
}
